<template>
  <div class="poster" v-if="clazz">
    <div class="title">点击下列图片分享班级信息</div>

    <div class="poster_list_wrap">
      <div class="poster_list" :style="`width:${210*3}px`">
        <img v-for="(image, index) in posterTemplates" :key="index" :src="`${image}?x-oss-process=style/poster_thumb`" @click="onRend(image)">
      </div>
    </div>

    <van-popup v-model="show">
      <img :src="imgPath" width="320px" alt="">
    </van-popup>

    <clazz-poster ref="clazzPoster" :poster-data="clazzPosterData" @success="success" @fail="fail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast, Popup, Button } from 'vant'
import ClazzPoster from '@/components/Poster/ClazzPoster'
import { clazzSimpleInfo } from '@/api/clazz'
import { ossToken } from '@/api/upload'

export default {
  name: 'poster',
  components: {
    // RecordPoster,
    [Popup.name]: Popup,
    [Button.name]: Button,
    ClazzPoster
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  data () {
    return {
      clazz: null,
      show: false,
      imgPath: '',
      posterTemplates: [
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_18.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_19.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_20.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_21.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_22.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_23.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_24.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_06.png',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_07.png',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_15.jpg',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_14.jpeg',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_12.png',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_13.jpg',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_05.jpg',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_01.jpg',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_02.png',
        // 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_04.jpg'
      ],
      clazzPosterData: {
        clazz_id: '',
        clazz_name: '班级名称班级名称',
        day_num: 30,
        day_distance: 3,
        enroll_end_time: '12月25日24点',
        join_start_time: '12月25日0点',
        join_end_time: '12月28日24点'
      }
    }
  },
  created () {
    const clazzId = this.$route.query.clazz_id || ''
    if (clazzId) {
      this.getClazzInfo(clazzId)
    }
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
      this.clazzPosterData = {
        clazz_id: this.clazz.uuid,
        clazz_name: this.clazz.clazz_name,
        day_num: this.clazz.day_num,
        day_distance: this.clazz.day_distance,
        enroll_end_time: this.clazz.enroll_end_time_format3,
        join_start_time: this.clazz.start_time_format3,
        join_end_time: this.clazz.end_time_format3,
        shareUser: this.userprofile.uuid
      }
    },

    async getOssToken () {
      const now = Date.parse(new Date()) / 1000
      if (!this.ossToken || this.ossToken.expire < now + 3) {
        const response = await ossToken({ mold: 'clazz_poster' })
        this.ossToken = response.data
      }
    },
    onRend (image) {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      this.$refs.clazzPoster.renderByBg(image)
    },
    success (src) {
      this.show = true
      this.imgPath = src
      Toast.clear()
    },
    fail (err) {
      Toast.clear()
      console.log('fail', err)
    }
  }
}
</script>

<style lang="scss">
.poster {
  // .help-text {
  //     position: absolute;
  //     color: #fff;
  //     top: 160px;
  //     z-index: 2002;
  //     font-size: 40px;
  //     width: 750px;
  //     text-align: center;
  //   }
  .van-popup {
    width: 600px;
  }
  .title {
    padding: 100px 0 20px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .poster_list_wrap {
    margin-top: 80px;
    /* 水平滚动 */
    overflow-x: scroll;
    /* 垂直隐藏 */
    overflow-y: hidden;
    width: 100%;
  }
  .poster_list {
    display: flex;
    // width: 200%;
    flex-flow: row nowrap;
    overflow-x: scroll;
    img {
      width: 360px;
      margin-right: 20px;
    }
  }
}
</style>
